import styled, { keyframes } from 'styled-components'
import { transparentize } from 'polished'

import { THEMES } from '../../styles'

const linearGradient = ({ theme } = {}) => {
  const THEME = THEMES[theme] || THEMES.light
  return `
    linear-gradient(
      to right,
      ${transparentize(1, THEME.background.primary)} 0%,
      ${transparentize(0.8, THEME.background.primary)} 20%,
      ${transparentize(0.5, THEME.background.primary)} 60%,
      ${transparentize(1, THEME.background.primary)} 100%
    );
  `
}
const maskImage = ({ theme } = {}) => {
  const THEME = THEMES[theme] || THEMES.light
  return `
    radial-gradient(
      ${transparentize(1, THEME.background.primary)},
      ${transparentize(0, THEME.background.primary)}
    );
  `
}

const wave = keyframes`
  0% {
    left: -100%;
  }
  50% {
    left: 100%;
  }
  100% {
    left: 100%;
  }
`
const Styled = styled.div`
  position: absolute;
  overflow: hidden;
  inset: 0;
  height: 100%;
  width: 100%;
  cursor: wait;

  /* Fix bug in Safari https://bugs.webkit.org/show_bug.cgi?id=68196 */
  mask-image: ${({ theme }) => maskImage({ theme })};

  &:before {
    content: '';
    display: block;
    position: absolute;
    left: -100%;
    top: 0;
    height: 100%;
    width: 100%;
    background: ${({ theme }) => linearGradient({ theme })};
    animation: ${wave} 1.6s linear 0.8s infinite;
    z-index: 1;
  }
`

export default Styled
